export default __webpack_public_path__ + "static/SongThrush-b21b6444aafd101390336d44d5e637be.jpeg";